import { Cursor } from "@nova/constants"
import { selectViewers } from "features/pubsub/slice"
import store, { socket } from "integrations/redux/store"

export const updateMouse = ({
    mouse,
    projectId,
    userId,
}: {
    mouse: Cursor["mouse"]
    projectId: string
    userId: string
}) => {
    const viewers = selectViewers()(store.getState())
    if (viewers.length > 0) socket?.emit("mouse", projectId, userId, mouse as Cursor["mouse"])
}
